export default {
    DOWNLOAD_DYNAMIC_DOCUMENT: "DOWNLOAD_DYNAMIC_DOCUMENT"
}